/**
 * Sagapo newsletter section: submit customer form via fetch so the page does not reload.
 * Success is detected from the final response URL or HTML (Shopify appends customer_posted=true).
 */
(function () {
  'use strict';

  /**
   * @param {HTMLElement} section - Root element with [data-section-type="custom-newsletter"]
   */
  function initSaNewsletter(section) {
    const form = section.querySelector('form[data-sa-newsletter-form]');
    if (!form || form.dataset.saNewsletterBound === 'true') return;
    form.dataset.saNewsletterBound = 'true';

    const fieldsRoot = section.querySelector('[data-sa-newsletter-fields]');
    const successEl = section.querySelector('[data-sa-newsletter-success]');
    const errorEl = section.querySelector('[data-sa-newsletter-error]');
    const submitBtn = form.querySelector('button[type="submit"]');

    const errorMsg = section.dataset.errorMessage || 'Something went wrong. Please try again.';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.setAttribute('hidden', '');
        errorEl.classList.add('tw-hidden');
      }

      const formData = new FormData(form);
      const action = form.getAttribute('action') || '/contact';

      fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          const url = response.url || '';
          if (url.indexOf('customer_posted=true') !== -1) {
            return { ok: true };
          }
          return response.text().then(function (html) {
            if (html.indexOf('customer_posted=true') !== -1) {
              return { ok: true };
            }
            const match = html.match(/class="[^"]*errors[^"]*"[^>]*>([\s\S]*?)<\/div>/i);
            const snippet = match ? match[1].replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() : '';
            return { ok: false, detail: snippet };
          });
        })
        .then(function (result) {
          if (result && result.ok) {
            if (errorEl) {
              errorEl.textContent = '';
              errorEl.setAttribute('hidden', '');
              errorEl.classList.add('tw-hidden');
            }
            if (successEl) {
              successEl.removeAttribute('hidden');
              successEl.classList.remove('tw-hidden');
              successEl.focus();
            }
            if (fieldsRoot) {
              fieldsRoot.setAttribute('hidden', '');
              fieldsRoot.classList.add('tw-hidden');
            }
          } else {
            const text = result && result.detail ? result.detail : errorMsg;
            if (errorEl) {
              errorEl.textContent = text || errorMsg;
              errorEl.removeAttribute('hidden');
              errorEl.classList.remove('tw-hidden');
            }
          }
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = errorMsg;
            errorEl.removeAttribute('hidden');
            errorEl.classList.remove('tw-hidden');
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="custom-newsletter"]').forEach(initSaNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const target = e.target;
    if (target && target.matches && target.matches('[data-section-type="custom-newsletter"]')) {
      initSaNewsletter(target);
    }
  });
})();
